import { IWorkOrder } from "./work-order";

export interface IHistoricalWO extends IWorkOrder {
    id?: number;
    workOrderId?: number;
    componentName?: string;
    finalCost?: number;
    finalTime?: number;
    observations?: string;
    responsibleId?: number;
    responsible?: string;
    resources?: string;
    creatorName?: string;
    photo1?: string;
    photo2?: string;
    photo3?: string;
    orderId?: number;
    maintenanceProvider?: string;
    created?: string;
    date?: string;

  }

  export class HistoricalWO  implements IHistoricalWO  {

    active?: number;
    activityId?: number;
    areaName?: string;
    authorized?: number;
    authorizesId?: number;
    authorizesName?: string;
    code?: string = "";
    componentName?: string;
    consecutive?: number;
    cost?: number;
    creatorId?: number;
    creatorName?: string;
    created?: string;
    currentOdometer?: number;
    date?: string;
    description?: string;
    equipmentId?: number;
    estimatedTime?: number;
    executionDate?: string;
    finalCost?: number;
    finalTime?: number;
    id?: number;
    maintenanceType?: string;
    maintenanceProvider?: string;
    observations?: string;
    odometer?: number;
    orderId?: number;
    photo1?: string;
    photo2?: string;
    photo3?: string;
    resources?: string;
    responsible?: string;
    responsibleId?: number;
    requests?: number;
    requestsName?: string;
    workOrderId?: number;
    invoiceReference?: string;
  }
